import { query } from '@/utils/request';

// 团队列表
export async function getVirtualOrganizationList(data) {
  return query('/zlb/budget/ep/virtual/page', {
    method: 'POST',
    data,
  });
}

// 获取团队详情
export async function getVirtualOrganizationDetail(params) {
  return query('/zlb/budget/ep/virtual/detail', {
    method: 'GET',
    params,
  });
}

// 编辑/新增团队
export async function saveVirtualOrganization(data) {
  return query('/zlb/budget/ep/virtual/save-or-update', {
    method: 'POST',
    data,
  });
}

// 启用/禁用虚拟团队
// export async function openVirtualOrganization(data) {
//   return query('/zlb/budget/ep/virtual/toggle-enable', {
//     method: 'POST',
//     data
//   });
// };

// 校验团队名称不能重复
export async function checkVirtualOrganizationName(params) {
  return query('/zlb/budget/ep/virtual/check', {
    method: 'GET',
    params,
  });
}

// 删除前校验绑定预算
export async function checkVirtualOrganizationBind(params) {
  return query('/zlb/budget/ep/virtual/check-bind', {
    method: 'GET',
    params,
  });
}

// 删除虚拟团队
export async function deleteVirtualOrganization(data) {
  return query('/zlb/budget/ep/virtual/delete', {
    method: 'POST',
    data,
  });
}

// 关联选择虚拟团队列表
export async function searchVirtualOrganizationList(data) {
  return query('/zlb/budget/ep/virtual/list', {
    method: 'POST',
    data,
  });
}
